import { isDev } from '@pkg/shared/env'
import type { NotificationInstance } from 'antd/es/notification/interface'

let instance: NotificationInstance | null = null

/**
 * Stable handle to the root <App> notification instance. Call toast.success(...) anywhere —
 * including non-React code like a form's onSubmit — with no hook and no optional chaining.
 * Backed by <ToastBridge>, which must be mounted once inside the root <App>. Using it before
 * the bridge mounts throws in dev and warns in prod (then no-ops).
 */
export const toast = new Proxy({} as NotificationInstance, {
  get(_target, key) {
    return (...args: unknown[]) => {
      if (!instance) {
        const reason = `toast.${String(key)}() called before <ToastBridge> mounted`
        if (isDev) throw new Error(reason)
        // Warn in production when toast is called before bridge is mounted
        // biome-ignore lint/suspicious/noConsole: intentional warning on misconfiguration
        console.warn(reason)
        return
      }
      const fn = instance[key as keyof NotificationInstance] as (...a: unknown[]) => unknown
      return fn(...args)
    }
  },
})

export function setToastInstance(notification: NotificationInstance | null) {
  instance = notification
}
